export default "__VITE_ASSET__6f2850f9__"